<template>
  <div class="das-info-list-label">
    <slot></slot>
  </div>
</template>
<script>
export default {
  // props: {
  //   required: {
  //     type: Boolean,
  //     default: false
  //   }
  // }
}
</script>
<style lang="scss">
.das-info-list-label {
  max-width: 300px;
  font-weight: 700;
  padding-right: 14px;
  font-size: 14px;
}
.label-required {
  // background: red;
  position: relative;
  &:after {
    content: '*';
    font-size: 15px;
    color: red;
    width: 5px;
    height: 5px;
    position: absolute;
    top: -8px;
    right: -5px;
  }
}
</style>
